import { isSb7aLoanTypeAtom } from "@/financeModels/owasco/general";
import { useAtomValue } from "jotai";
import { Outlet } from "react-router-dom";
import { Page } from "../Page";
import { SidebarHeadline } from "../Sidebar/SidebarHeadline";
import { sidebarModules } from "./Sidebar/moduleManifest";

export const ModelLoanPage = () => {
  const isSb7aLoanType = useAtomValue(isSb7aLoanTypeAtom);

  const modules = sidebarModules.map((item) => ({
    ...item,
    control: item.control
      .replace(
        isSb7aLoanType ? "xx" : "Lender Line Of Credit",
        "Line of Credit",
      )
      .replace(isSb7aLoanType ? "xx" : "SBA 7(a) Loan", "Senior Debt"),
  }));

  return (
    <Page
      sidebarTop={
        <SidebarHeadline
          title={"Cash Flow Model"}
          docPath={"@/docs/pages/model/sidebar/getting-started.mdx"}
        />
      }
      sidebarModules={modules}
      accordionId={"loanAccordion"}
    >
      <Outlet />
    </Page>
  );
};
